import { useMutation, useQueryClient } from '@tanstack/react-query'

import { transferServices } from '../transferServices'
import { CreateSavingGoalPayload, SavingGoalDTO } from '../transferTypes'
import { QUERY_KEYS } from '@/constants/queryKeys'

export interface IOptionsUseMutation<TData> {
  onSuccess?: (data: TData) => void
  onError?: (error: { errorMessage?: string; code?: string }) => void
}

export const useCreateSavingGoal = (
  options?: IOptionsUseMutation<SavingGoalDTO>,
) => {
  const queryClient = useQueryClient()

  const mutation = useMutation<SavingGoalDTO, Error, CreateSavingGoalPayload>({
    mutationFn: transferServices.createSavingGoal,
    onSuccess: (data) => {
      queryClient.invalidateQueries({
        queryKey: [QUERY_KEYS.SAVING_GOALS],
      })

      if (options?.onSuccess) {
        options.onSuccess(data)
      }
    },
    onError: (err) => {
      if (options?.onError)
        options?.onError({
          errorMessage: 'Something went wrong',
          code: 'UNKNOWN_ERROR',
        })
    },
  })

  return {
    ...mutation,
  }
}
